module.exports = __webpack_public_path__ + "img/header.69f70517.jpg";